import React, { useContext, useState } from 'react';
import { FaWandMagicSparkles as MagicStickIcon } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { StateContext } from '../../StateContainer';
import { MarkerType } from '@xyflow/react';
import MagicLoading from '../loading/MagicLoading';
import { extractOutputIntents } from '../../../utils/outputIntent';

const ModalAiJsonGenerator = () => {
  const {
    currentConversationalVersion,
    versioniAgenteConversazionale,
    setNodes,
    setEdges,
    nodes,
    edges,
    setDettagliNodi,
  } = useContext(StateContext);
  const [userInstructions, setUserInstructions] = useState('');
  const [loadingGeneration, setLoadingGeneration] = useState(false);
  const cancelJsonGeneratorButton = document.getElementById(
    'cancelJsonGeneratorButton',
  );

  const closeCancelJsonGeneratorButton = () => {
    if (cancelJsonGeneratorButton) {
      cancelJsonGeneratorButton.click();
    }
    return;
  };

  const CreaConversazioneJsonAI = () => {
    let currentUserInstructions = userInstructions;
    setUserInstructions('');
    closeCancelJsonGeneratorButton();
    setLoadingGeneration(true);
    let currentConversation = '';
    let versioneAttuale =
      versioniAgenteConversazionale &&
      versioniAgenteConversazionale.find(
        (v) => v.id === parseInt(currentConversationalVersion),
      );

    if (versioneAttuale) {
      currentConversation = versioneAttuale.conversationalJSON;
    } else {
      currentConversation = '';
    }

    if (userInstructions === '') {
      setLoadingGeneration(false);
      toast.error(
        "Per generare la conversazione, devi prima fornire delle istruzioni all'AI",
      );
      return;
    }
    const apiURL = `${process.env.REACT_APP_PYTHON_ENGINE}/create-json-conversation`;

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent':
          'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/113.0.0.0 Safari/537.36',
      },
      body: JSON.stringify({
        userInstructions: userInstructions,
        currentConversation: currentConversation,
      }),
    };

    fetch(apiURL, requestOptions)
      .then((response) => {
        // Controlla se la risposta è ok (status code 2xx)
        if (!response.ok) {
          setLoadingGeneration(false);
          toast.error("C'è stato un errore nella richiesta");

          // Puoi anche mostrare un messaggio di errore all'utente qui
          return;
        }
        // Leggi il corpo della risposta come JSON
        return response.json();
      })
      .then((data) => {
        // Ora 'data' conterrà l'oggetto JSON restituito dal backend
        if (data && data.conversationalJSON) {
          let conversationalJSON = data.conversationalJSON;
          AssegnaNuovoConversationalJSON(JSON.parse(conversationalJSON));
          setLoadingGeneration(false);
          closeCancelJsonGeneratorButton();
        } else {
          setLoadingGeneration(false);
          toast.error("C'è stato un errore nella richiesta");
          // Gestisci il caso in cui la struttura della risposta non è quella prevista
        }
      })
      .catch((err) => {
        setLoadingGeneration(false);
        toast.error(`C'è stato un errore nella richiesta: ${err}`);
        // Gestisci l'errore di rete o altri errori
      });
  };

  const AssegnaNuovoConversationalJSON = (conversationalJSON) => {
    if (conversationalJSON) {
      let nodesConversationalJSON = conversationalJSON[0];
      const newNodes = Object.keys(nodesConversationalJSON)
        .filter((key) => key !== 'fullfillment_variables' && key !== 'viewport')
        .map((key) => {
          const nodeData = nodesConversationalJSON[key];
          const position = nodeData.position || { x: 0, y: 0 }; // fallback sicuro
          return {
            id: nodeData.id ? nodeData.id.toString() : '',
            type: nodeData.type,
            data: { label: nodeData.node_label, actions: [] },
            position: position,
          };
        });

      setNodes(newNodes);

      const listFullfillmentVariables =
        nodesConversationalJSON.fullfillment_variables || [];

      const fullfillmentVariables = listFullfillmentVariables.filter(
        (fv) =>
          fv.label === '' &&
          fv.nome_variabile === '' &&
          fv.istruzioni_estrazione === '',
      );

      const newDettagliNodi = Object.keys(nodesConversationalJSON).reduce(
        (acc, key) => {
          if (key !== 'fullfillment_variables' && key !== 'viewport') {
            const nodeData = nodesConversationalJSON[key];
            acc[key] = {
              node_label: nodeData.node_label,
              id: nodeData.id,
              type: nodeData.type,
              position: nodeData.position,
              intents: nodeData.intents || [],
              fullfillment:
                fullfillmentVariables.filter(
                  (fv) => fv.nodeId === nodeData.id,
                ) || [],
            };
          }
          return acc;
        },
        {},
      );

      const newEdges = [];
      Object.keys(newDettagliNodi).forEach((key) => {
        const node = newDettagliNodi[key];
        if (node.intents) {
          node.intents.forEach((intent) => {
            let target = intent.target.toString();
            let source = node.id.toString();
            newEdges.push({
              id: `${node.id}-${intent.target}`,
              source: node.id.toString(),
              target: intent.target.toString(),
              animated: true,
              type: source === target ? 'selfconnecting' : 'custom_edge',
              markerEnd: {
                type: MarkerType.ArrowClosed,
                width: 20,
                height: 20,
              },
              data: {
                trigger: intent.trigger,
                ...extractOutputIntents(intent),
                forceIntent: intent.forceIntent,
                type: 'action',
                id: intent.id,
                target: intent.target,
                source: node.id,
              },
            });
          });
        }
      });

      setEdges(newEdges);

      // Dettagli nodi
      setDettagliNodi(conversationalJSON[0]);
    }
  };

  return loadingGeneration ? (
    <MagicLoading />
  ) : (
    <div
      className="modal fade overlay"
      id="ModalAiJsonGenerator"
      tabIndex="-1"
      aria-labelledby="ModalAiJsonGenerator"
      aria-hidden="true"
      data-bs-backdrop="false"
      style={{ zIndex: '99999999999999999999999999999999999' }}
    >
      <div className="modal-dialog modal-dialog-centered text-center">
        <div className="modal-content">
          <div className="modal-header border-0 py-4">
            <h5 className="modal-title d-flex align-items-center justify-content-start gap-2">
              <MagicStickIcon /> Genera conversazione con AI
            </h5>
          </div>
          <div className="modal-body">
            {/* TEXTAREA INDICAZIONI CREAZIONE JSON CON AI  */}
            <div class="mb-3 text-start">
              <label for="exampleFormControlTextarea1" class="form-label">
                Istruzioni di creazione
              </label>
              <textarea
                class="form-control"
                id="exampleFormControlTextarea1"
                style={{ minHeight: '300px' }}
                value={userInstructions}
                onChange={(e) => setUserInstructions(e.target.value)}
                placeholder="Fornisci delle istruzioni all'AI per generare la tua conversazione"
              ></textarea>
            </div>
          </div>
          <div className="modal-footer">
            <div className="d-flex w-100 gap-2">
              <button
                type="button"
                className="btn btn-secondary w-50"
                data-bs-dismiss="modal"
                id="cancelJsonGeneratorButton"
              >
                Annulla
              </button>
              <button
                type="button"
                className={`btn magic-stick-button text-dark w-50 ${
                  loadingGeneration && 'disabled'
                }`}
                onClick={CreaConversazioneJsonAI}
                id="creaProgettoButton"
              >
                Crea
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalAiJsonGenerator;
